import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight, FiDatabase, FiFileText, FiLock, FiLogOut, FiShield, FiUser } from "react-icons/fi";
import { useAuth } from "../context/AuthContext.tsx";
import { useSourceConnections } from "../hooks/useSourceConnections";
import "./ProfilePage.css";

const ProfilePage:React.FC=()=>{
  const {user,isAuthenticated,isLoading,logout,loginWithGoogle}=useAuth();
  const {counts}=useSourceConnections();
  return <main className="h-page h-profile"><div className="h-container">
    <span className="h-eyebrow"><FiUser size={15}/> IDENTITY & PERMISSIONS</span>
    <h1 className="h-display">Your Handle.<br/><span className="h-gradient-text">Only yours.</span></h1>
    <p className="h-lead">One place to manage your identity, connections and submission history. A linked account never automatically gives buyers access to your data.</p>
    {!isAuthenticated?<div className="h-profile-card h-panel h-panel-padding">
      <FiLock className="h-profile-icon" size={34}/>
      <h2>Sign in to access your identity.</h2>
      <p>Your evidence and connections are private. You choose what enters the marketplace.</p>
      <button type="button" className="h-btn h-btn-primary" disabled={isLoading} onClick={loginWithGoogle}>Sign in with Google <FiArrowRight/></button>
    </div>:<>
      <section className="h-section h-profile-card h-panel h-panel-padding">
        <div className="h-profile-avatar">{user?.firstName?.charAt(0)?.toUpperCase()||"H"}</div>
        <div className="h-profile-details"><span className="h-small-label">GOOGLE IDENTITY</span><h2>{[user?.firstName,user?.lastName].filter(Boolean).join(" ")||"Handle member"}</h2><p>{user?.email}</p><span className="h-pill h-pill-success"><FiShield size={13}/> Signed in</span></div>
        <button type="button" className="h-btn h-btn-secondary h-profile-logout" onClick={logout}><FiLogOut/> Sign out</button>
      </section>
      <section className="h-section h-profile-quicklinks"><Link className="h-panel h-panel-padding" to="/connections">
        <FiDatabase size={23}/><div><strong>{counts.verified} authenticated sources</strong><span>{counts.claimed} username claims · edit or reconnect</span></div><FiArrowRight/></Link>
        <Link className="h-panel h-panel-padding" to="/evidence"><FiFileText size={23}/><div><strong>Purchase & subscription evidence</strong><span>Forward confirmations, manage private receipts</span></div><FiArrowRight/></Link></section>
      <section className="h-section h-panel h-panel-padding h-profile-note">
        <FiLock size={22}/><div><h2>Consent is separate from connection.</h2><p>Handle requires explicit terms before any data can be licensed. The buyer marketplace is currently a simulation; no real contracts, data transfer or payouts are active.</p></div>
      </section>
    </>}
  </div></main>;
};
export default ProfilePage;
